import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DirectionsBoatFilledRoundedIcon from '@mui/icons-material/DirectionsBoatFilledRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import { Button } from "@deere/fuel-react";

export const LoadBuildDialog = (props) => {
  const { open, handleApply, handleClose, dialogContent } = props;
  const transportMode = dialogContent?.props?.selectedMachinesForBuild?.[0]?.transportMode;

  return (
    <div className="w-full">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          {(transportMode === "VESSEL" || transportMode === "FERRY") ? (
            <DirectionsBoatFilledRoundedIcon className="mr-1 text-green-700" />
          ) : (
            <LocalShippingRoundedIcon className="mr-1 text-green-700" />
          )}
          {`Load build & Pick Up `}
        </DialogTitle>
        <DialogContent>{dialogContent}</DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            variant="primary"
            size="small"
            onClick={() => handleApply()}
          >
            Apply
          </Button>
          <Button variant="secondary" size="small" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
